<template>
  <div class="ui-testimonial-card">
    <span class="ui-testimonial-card__stars">★★★★★</span>
    <p class="ui-testimonial-card__quote">&ldquo;{{ quote }}&rdquo;</p>
    <div class="ui-testimonial-card__author">
      <span class="ui-testimonial-card__avatar">{{ initial }}</span>
      <div class="ui-testimonial-card__info">
        <span class="ui-testimonial-card__name">{{ name }}</span>
        <span class="ui-testimonial-card__role">{{ role }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  quote: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  role: {
    type: String,
    required: true,
  },
});

const initial = computed(() => props.name.trim().charAt(0).toUpperCase());
</script>

<style scoped>
.ui-testimonial-card {
  display: flex;
  flex-direction: column;
  gap: var(--gap-lg);
  background: var(--navy-card);
  border: 1px solid var(--navy-border);
  border-radius: var(--r-lg);
  padding: 32px;
  height: 100%;
}

.ui-testimonial-card__stars {
  color: var(--cyan);
  font-size: 16px;
  letter-spacing: 2px;
}

.ui-testimonial-card__quote {
  font-family: var(--font-brand);
  font-size: 14px;
  font-style: italic;
  line-height: 1.75;
  color: var(--text);
}

.ui-testimonial-card__author {
  display: flex;
  align-items: center;
  gap: var(--gap-md);
  margin-top: auto;
}

.ui-testimonial-card__avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  flex-shrink: 0;
  border-radius: 50%;
  background: var(--navy-mid);
  border: 2px solid var(--navy-border);
  font-family: var(--font-brand);
  font-size: 14px;
  font-weight: 700;
  color: var(--cyan);
}

.ui-testimonial-card__info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.ui-testimonial-card__name {
  font-family: var(--font-brand);
  font-size: 13px;
  font-weight: 600;
  color: var(--white);
}

.ui-testimonial-card__role {
  font-family: var(--font-brand);
  font-size: 12px;
  color: var(--muted);
}
</style>
